'use client';
import { memo, useState } from 'react';
import { HStack, VStack } from '@chakra-ui/react';

import { breakpoints } from 'app/themeConfig';
import SliderControls from 'features/SliderControls';
import { useSwiperControls } from 'shared/hooks';
import SpecialistCard from './SpecialistCard';
import BlockHeader from 'shared/BlockHeader';
import ButtonGoTo from 'shared/ButtonGoTo';
import Slider from 'shared/Slider';

import { specialistCardsData } from 'constants/Specialists';

const Specialists = () => {
  const [swiper, setSwiper] = useState(null);
  const controls = useSwiperControls(swiper);

  return (
    <VStack
      as="section"
      w="full"
      align="start"
      gap={{ laptop: '40px', tablet: '24px', mobile: '20px' }}
    >
      <HStack w="full" align="end" justifyContent="space-between">
        <BlockHeader maxW={{ mobile: '342px', tablet: '610px', laptop: '920px' }}>
          70% команды — специалисты среднего и ведущего уровня (Middle и Senior)
        </BlockHeader>

        <SliderControls {...controls} />
      </HStack>

      <Slider
        controller={swiper}
        setController={setSwiper}
        slidesData={specialistCardsData}
        SlideComponent={SpecialistCard}
        mousewheel={false}
        spaceBetween="16px"
        breakpoints={{
          [parseInt(breakpoints.xm)]: { slidesPerView: 'auto' },
          [parseInt(breakpoints.laptop)]: { slidesPerView: 'auto', spaceBetween: '20px' },
        }}
      />

      <ButtonGoTo size="secondary" w="full" btnText="Запросить резюме" />
    </VStack>
  );
};

export default memo(Specialists);
